export type StoreHoursEntry = {
    days: string; // e.g. "Mon-Thu", "Sun"
    hours: string; // e.g. "9 AM - 6 PM" or "Closed"
};

export const storeHours: StoreHoursEntry[] = [
    { days: 'Mon-Thu', hours: '9 AM - 6 PM' },
    { days: 'Fri-Sat', hours: '8 AM - 5 PM' },
    { days: 'Sun', hours: 'Closed' },
];
